import React from "react";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

export const ColorPickerField = ({ label, value, onChange, testId }) => {
  return (
    <div className="flex items-center justify-between gap-4 py-2 border-b border-border/40">
      <Label className="text-sm uppercase tracking-[0.18em] font-medium text-foreground/80">
        {label}
      </Label>
      <div className="flex items-center gap-3">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-14 cursor-pointer rounded-md border border-border bg-transparent p-0"
          data-testid={`${testId}-picker`}
        />
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-28 font-mono text-sm uppercase"
          data-testid={`${testId}-input`}
        />
      </div>
    </div>
  );
};
